export default function isPostLiked({ user, post }) {
  if (!post.hasOwnProperty("likes") || post.likes.filter((l) => l && l.id === user.id).length === 0) {
    return false;
  } else {
    return true;
  }
}
